(function () {
  var FREE_SHIPPING_VARIANT_ID = 53299544883499;
  var FREE_SHIPPING_PLAN_BY_CADENCE = {
    30: 116897120555,
    45: 118694871339,
    60: 118651191595,
    75: 118694904107,
    90: 118694936875
  };
  var FREE_SHIPPING_PLAN_ALIASES = { 119366811947: 116897120555 };
  var reconcilePromise = null;
  var scheduledTimer = null;

  function cartUrl(path) {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + path;
  }

  function isFreeShippingLine(item) {
    return Number(item.variant_id || item.id) === FREE_SHIPPING_VARIANT_ID;
  }

  function hasSellingPlan(item) {
    return Boolean(item.selling_plan_allocation);
  }

  function cadenceFromItem(item) {
    var allocation = item && item.selling_plan_allocation;
    var plan = allocation && allocation.selling_plan;
    var planId = Number(plan && plan.id);
    if (FREE_SHIPPING_PLAN_ALIASES[planId]) return 30;
    var knownCadence = Object.keys(FREE_SHIPPING_PLAN_BY_CADENCE).find(function(days) {
      return FREE_SHIPPING_PLAN_BY_CADENCE[days] === planId;
    });
    if (knownCadence) return Number(knownCadence);
    var match = String(plan && plan.name || '').match(/(30|45|60|75|90)/);
    return match ? Number(match[1]) : 0;
  }

  function desiredFreeShippingPlan(cart) {
    var subscriptionLine = (cart.items || []).find(function(item) {
      return !isFreeShippingLine(item) && hasSellingPlan(item);
    });
    var cadence = cadenceFromItem(subscriptionLine);
    return cadence ? FREE_SHIPPING_PLAN_BY_CADENCE[cadence] : 0;
  }

  function getCartHandler() {
    return document.querySelector('[nss-cart-handler]');
  }

  function getSectionId() {
    var cartHandler = getCartHandler();
    return cartHandler ? cartHandler.getAttribute('nss-parent-section-id') || '' : '';
  }

  function getSectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function refreshCart(cart) {
    var cartHandler = getCartHandler();
    var sectionId = getSectionId();
    var sectionHtml = sectionId && cart.sections && cart.sections[sectionId];
    if (!cartHandler || !sectionHtml) {
      if (window.location.pathname === '/cart') window.location.reload();
      return;
    }

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var currentList = cartHandler.querySelector('[nss-cart-product-list]');
    var nextList = doc.querySelector('[nss-cart-product-list]');
    if (currentList && nextList) currentList.replaceWith(nextList);

    cartHandler.querySelectorAll('[nss-cart-reload]').forEach(function (current) {
      var key = current.getAttribute('nss-cart-reload');
      var replacement = doc.querySelector('[nss-cart-reload="' + key + '"]');
      if (replacement) current.replaceWith(replacement);
      else current.remove();
    });

    var itemCount = nextList && nextList.getAttribute('nss-cart-item-count');
    if (itemCount != null) {
      document.querySelectorAll('[nss-cart-count],[nss-cart-badge-count]').forEach(function (node) {
        node.innerHTML = itemCount;
      });
    }
  }

  function reconcile() {
    if (reconcilePromise) return reconcilePromise;

    reconcilePromise = fetch(cartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var freeShippingLines = (cart.items || []).filter(isFreeShippingLine);
        var desiredPlan = desiredFreeShippingPlan(cart);

        if (!freeShippingLines.length) {
          return { cart: cart, removed: false };
        }

        var sectionId = getSectionId();
        var request;
        if (!desiredPlan) {
          var payload = { updates: {} };
          freeShippingLines.forEach(function (item) { payload.updates[item.key] = 0; });
          if (sectionId) {
            payload.sections = sectionId;
            payload.sections_url = getSectionsUrl();
          }
          request = fetch(cartUrl('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
        } else {
          var primary = freeShippingLines[0];
          var currentPlan = Number(primary.selling_plan_allocation && primary.selling_plan_allocation.selling_plan && primary.selling_plan_allocation.selling_plan.id);
          if (currentPlan === desiredPlan && freeShippingLines.length === 1) {
            return { cart: cart, removed: false };
          }
          var changePayload = { id: primary.key, quantity: 1, selling_plan: desiredPlan };
          if (sectionId) {
            changePayload.sections = sectionId;
            changePayload.sections_url = getSectionsUrl();
          }
          request = fetch(cartUrl('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(changePayload)
          });
        }

        return request
          .then(function (response) { return response.json(); })
          .then(function (updatedCart) {
            refreshCart(updatedCart);
            return { cart: updatedCart, removed: !desiredPlan };
          });
      })
      .finally(function () {
        reconcilePromise = null;
      });

    return reconcilePromise;
  }

  function scheduleReconcile(delay, force) {
    if (!force && !document.querySelector('[data-variant-id="' + FREE_SHIPPING_VARIANT_ID + '"]')) return;
    clearTimeout(scheduledTimer);
    scheduledTimer = setTimeout(function () {
      reconcile().catch(function (error) {
        console.error('Free Shipping cart guard failed:', error);
      });
    }, delay || 500);
  }

  function waitForCartMutations() {
    return new Promise(function (resolve) {
      var attempts = 0;
      function check() {
        attempts += 1;
        if (!document.querySelector('[nss-cart-item-loading="true"]') || attempts >= 75) {
          resolve();
          return;
        }
        setTimeout(check, 200);
      }
      setTimeout(check, 50);
    });
  }

  function isCheckoutControl(element) {
    return element && element.matches && element.matches(
      '[nss-cart-checkout-btn], [name="checkout"], a[href="/checkout"], a[href$="/checkout"]'
    );
  }

  function continueCheckout(control) {
    var checkoutUrl = control.getAttribute('data-checkout-url') || control.getAttribute('href') || '/checkout';
    if (control.form) {
      HTMLFormElement.prototype.submit.call(control.form);
      return;
    }
    window.location.assign(checkoutUrl);
  }

  document.addEventListener('click', function (event) {
    var checkoutControl = event.target.closest && event.target.closest(
      '[nss-cart-checkout-btn], [name="checkout"], a[href="/checkout"], a[href$="/checkout"]'
    );

    if (isCheckoutControl(checkoutControl)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      waitForCartMutations()
        .then(reconcile)
        .then(function (result) {
          if (!result.removed || Number(result.cart.item_count) > 0) continueCheckout(checkoutControl);
        })
        .catch(function (error) {
          console.error('Free Shipping checkout guard failed:', error);
        });
      return;
    }

    var cartControl = event.target.closest && event.target.closest(
      '[nss-cart-remove], [nss-cart-qty-minus], [nss-cart-qty-plus], [nss-cart-selling-plan-btn]'
    );
    if (cartControl) {
      waitForCartMutations()
        .then(reconcile)
        .catch(function (error) {
          console.error('Free Shipping cart guard failed:', error);
        });
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('[name="updates[]"], [nss-cart-size-select], [nss-cart-selling-plan-select]')) {
      scheduleReconcile(900);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.submitter || !isCheckoutControl(event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    waitForCartMutations()
      .then(reconcile)
      .then(function (result) {
        if (!result.removed || Number(result.cart.item_count) > 0) continueCheckout(event.submitter);
      })
      .catch(function (error) {
        console.error('Free Shipping checkout guard failed:', error);
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleReconcile(0); });
  } else {
    scheduleReconcile(0);
  }

  window.addEventListener('pageshow', function () { scheduleReconcile(0); });
  document.addEventListener('ap:cart-updated', function () { scheduleReconcile(0, true); });

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : request && request.url || '';
    var responsePromise = nativeFetch.apply(this, arguments);
    if (url.indexOf('cart/add.js') !== -1) {
      responsePromise.then(function () {
        scheduleReconcile(600, true);
      }).catch(function () {});
    }
    return responsePromise;
  };
})();
